module.exports = __webpack_public_path__ + "img/logo.5a8fe25b.jpg";